import styled from 'styled-components';
import { colors } from 'core/theme';

export const StyledNav = styled.nav`
  display: flex;
  align-items: center;
  margin-right: 1em;

  & > ul {
    list-style: none;
    margin: 0;
    padding-left: 0;

    display: flex;

    & > li:not(:last-child) {
      margin-right: 0.5em;
    }

    & > li:not(:first-child) {
      border-left: 1px solid ${colors.hairline};
      padding-left: 0.5em;
    }

    & a {
      color: ${colors.subtleText};
      text-decoration: none;

      &:hover {
        color: ${colors.text};
        text-decoration: underline;
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/modules/Header/components/LanguagesNav/styled.js